import React from 'react'
import PropTypes from 'prop-types'
import { RuleInfoContent, RuleInfoWrapper } from './elements'
import { Typography } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import AssignmentIcon from '@mui/icons-material/Assignment'
import BookIcon from '@mui/icons-material/Book'

const RuleInfoItem = ({ timer, amount, type }) => {
  return (
    <RuleInfoWrapper>
      <RuleInfoContent>
        <AccessTimeIcon fontSize="small" />
        <Typography ml={1} fontWeight={300} variant="body2">
          {timer} <span>Menit </span>
        </Typography>
      </RuleInfoContent>
      <RuleInfoContent>
        <AssignmentIcon fontSize="small" />
        <Typography ml={1} fontWeight={300} variant="body2">
          {amount} <span>Soal</span>
        </Typography>
      </RuleInfoContent>
      <RuleInfoContent>
        <BookIcon fontSize="small" />
        <Typography ml={1} fontWeight={300} variant="body2">
          {type}
        </Typography>
      </RuleInfoContent>
    </RuleInfoWrapper>
  )
}

RuleInfoItem.propTypes = {
  timer: PropTypes.string,
  amount: PropTypes.string,
  type: PropTypes.string,
}

export default RuleInfoItem
